import AddIcon from "@/components/icons/AddIcon";
import StarsRateIcon from "@/components/icons/StarsRateIcon";
import { Fragment } from "react";
import { v4 as uuidv4 } from "uuid";

import { useTranslation } from "next-i18next";
import Loading2 from "@/components/global/Loading2";
import NextImage from "@/components/global/NextImage";
import { validateImgSrc } from "@/utils/global";

const Reviews = ({ isLoading, data, onClickShowMore }) => {
  const { t } = useTranslation("product");

  return isLoading ? (
    <Loading2 />
  ) : data?.reviews?.length ? (
    <>
      {(data?.reviews || []).map((review) => (
        <Fragment key={uuidv4()}>
          <div className="grid grid-cols-12 gap-3 sm:gap-0 py-3 border-b">
            <div className="col-span-full md:col-span-2 flex flex-col sm:items-start md:px-5">
              <div className="sm:block hidden size-20 bg-zinc-100 rounded-full relative overflow-hidden order-1">
                {review?.icon && (
                  <NextImage
                    src={validateImgSrc(review?.icon)}
                    className="object-cover border rounded-full"
                    alt="user-icon"
                    width={80}
                    height={80}
                  />
                )}
              </div>
              <span className="text-primary-800 font-bold sm:order-2 whitespace-nowrap block sm:hidden">
                {review?.author || ""}
              </span>
              <div className="flex sm:flex-col gap-1 sm:justify-normal justify-between items-center sm:items-start order-3 mt-2">
                <span className="text-primary-800">{review?.date || ""}</span>
                <StarsRateIcon rate={Math.floor(review?.score || 0) / 2} />
              </div>
            </div>
            <div className="col-span-full md:col-span-10 flex flex-col gap-5">
              <p className="text-zinc-400">{review?.extract || ""}</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                {review?.pros && (
                  <div className="flex flex-col gap-1.5">
                    <div className="flex items-center gap-3 text-green-500">
                      <div className="size-7 rounded-full flex items-center justify-center border border-green-500">
                        <AddIcon />
                      </div>
                      <span className="font-semibold">{t("Pros")}</span>
                    </div>
                    <p className="text-zinc-400 text-sm line-clamp-2">
                      {review?.pros}
                    </p>
                  </div>
                )}
                {review?.cons && (
                  <div className="flex flex-col gap-1.5">
                    <div className="flex items-center gap-3 text-warning">
                      <div className="size-7 rounded-full flex items-center justify-center border border-warning">
                        <AddIcon />
                      </div>
                      <span className="font-semibold">{t("Cons")}</span>
                    </div>
                    <p className="text-zinc-400 text-sm line-clamp-2">
                      {review?.cons}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Fragment>
      ))}
      {data?.next_page_url && (
        <button
          onClick={onClickShowMore}
          className="w-full p-2 text-primary-800 border hover:bg-primary-800 hover:text-white transition-all font-medium border-primary-800"
        >
          {t("show more")}
        </button>
      )}
    </>
  ) : (
    <div className="flex items-center justify-center min-h-44 text-slate-400 sm:text-xl">
      {t("There are no reviews for this product yet")}
    </div>
  );
};

export default Reviews;
